import { render } from "./ComponentList.vue?vue&type=template&id=44d8494f&scoped=true"
import script from "./ComponentList.vue?vue&type=script&lang=js"
export * from "./ComponentList.vue?vue&type=script&lang=js"

import "./ComponentList.vue?vue&type=style&index=0&id=44d8494f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d8494f"]])

export default __exports__